import * as RoutePathConstants from '../../../../constants/RoutePathConstants'
import pageMailService from './views/page-mail-service/page-mail-service'
import oneClickRenewal from './views/one-click-renewal/one-click-renewal'
import annualInspectionAgency from './views/annual-inspection-agency/annual-inspection-agency'
import oilCardRecharge from './views/oil-card-recharge/oil-card-recharge'
import financialService from './views/financial-service/financial-service'
import carWashService from './views/car-wash-service/car-wash-service'
import myCarServe from './views/my-car-serve/my-car-serve'
import extendedInsurance from './views/extended-insurance/extended-insurance'
import oneClickRescue from './views/one-click-rescue/one-click-rescue'

export default [
  {
    path: RoutePathConstants.PAGE_MAIL_SERVICE,
    name: 'pageMailService',
    component: pageMailService
  },
  {
    path: RoutePathConstants.ONE_CLICK_RENEWAL,
    name: 'oneClickRenewal',
    component: oneClickRenewal
  },
  {
    path: RoutePathConstants.ANNUAL_INSPECTION_AGENCY,
    name: 'annualInspectionAgency',
    component: annualInspectionAgency
  },
  {
    path: RoutePathConstants.OIL_CARD_RECHARGE,
    name: 'oilCardRecharge',
    component: oilCardRecharge
  },
  {
    path: RoutePathConstants.FINANCIAL_SERVICE,
    name: 'financialService',
    component: financialService
  },
  {
    path: RoutePathConstants.CAR_WASH_SERVICE,
    name: 'carWashService',
    component: carWashService
  },
  {
    path: RoutePathConstants.MY_CAR_SERVE,
    name: 'myCarServe',
    component: myCarServe
  },
  {
    path: RoutePathConstants.EXTENDED_INSURANCE,
    name: 'extendedInsurance',
    component: extendedInsurance
  },
  {
    path: RoutePathConstants.ONE_CLICK_RESCUE,
    name: 'oneClickRescue',
    component: oneClickRescue
  }
]


// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/page-mail-service/routers.js